import React from "react";

export default function ModuleHeading({
  title,
  backgroundColor = "#555453",
  fontSize = "22px",
  titleStyle = {},
  onClickBack = () => { },
  titleClassName = "",
  viewOnly = false
}) {
  return (
    <div
      className={`text-white pt-3 d-flex justify-content-center ${title === "Track And Trace" && `position-relative`
        }`}
      style={{
        backgroundColor: backgroundColor,
        fontSize: fontSize,
      }}
    >
      {title === "Track And Trace" && (
        <button
          onClick={onClickBack}
          className="btn btn-sm text-white position-absolute my-2"
          style={{
            left: "12px",
            backgroundColor: "transparent",
            fontSize: "13px",
          }}
        >
          <i className="fa fa-arrow-left" style={{ fontSize: "14px" }}></i>
        </button>
      )}
      <div className={`d-flex align-items-center ${titleClassName}`} style={titleStyle}>
        <span>
          {title}
        </span>
        <span className="px-2">
          {viewOnly && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '20px',
              padding: '0px 12px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              backdropFilter: 'blur(4px)',
              marginLeft: '10px'
            }}>
              <i className="fa fa-eye" style={{ marginRight: '6px', fontSize: '14px' }}></i>
              <span style={{ fontSize: '14px', fontWeight: '500' }}>View Only</span>
            </div>
          )}
        </span>
      </div>
    </div>
  );
}
